import { Component, OnInit } from '@angular/core';
import { ProductsService } from '@app/services/maxi/products.service';
import { ToastrService } from 'ngx-toastr';
import { LoopBackConfig, LoopBackAuth, UserData, UserDataApi, ConfigurationApi, OrderApi } from '../../../../assets/js/lb-sdk';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  constructor(private products: ProductsService,
    private toaster: ToastrService,
    private loopBackAuth: LoopBackAuth,
    private userDataApi: UserDataApi,
    private orderApi: OrderApi) { }

  ngOnInit() {
    this.products.findAll()
  }

  getProducts() {
    return this.products.products$
  }
  update({id,name,active}) {
    this.products.update(id,{ active: !active })
      .subscribe(value => {
        let message = !active 
          ? name + ' activated'
          : name + ' deactivated'
        this.toaster.success(message,'Product Status')
        this.products.findAll()
      })
  }

  generate(event) {
    console.log(event)
    const id = this.getUser().id
    const user$ = this.userDataApi.findById(id)

    /*
    this.orderApi.create({},function(data,data2) {
      return noted
    })
    forkJoin(user$)
    .subscribe( ([response]) => {
      console.log('forkas join sub',response)
      this.toaster.success('Reference codes emailed', 'Generate')
    })
    */
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }


}
